import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_DUNOCHOVAY } from "../actions/DuNoChoVay/actionTypes";
import {
  getListDuNoChoVaySuccess,
  getListDuNoChoVayFailure,
} from "../actions/DuNoChoVay";
import DuNoChoVayApi from "../service/duNoChoVayApi";

function* getListDuNoChoVay(action) {
  try {
    const response = yield call(DuNoChoVayApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListDuNoChoVaySuccess(response.data));
    } else {
      yield put(getListDuNoChoVayFailure());
    }
  } catch (error) {
    yield put(getListDuNoChoVayFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_DUNOCHOVAY, getListDuNoChoVay);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
